import { Action, createReducer, on } from '@ngrx/store';
import {
    loadCandidateContractsFailure,
    loadCandidateContractsSuccess,
    loadContractFailure,
    loadContractLookupFailure,
    loadContractLookupSuccess,
    loadContractSuccess,
    loadContractDetailsSuccess,
    loadStatesFailure,
    loadStatesSuccess,
    loadTicketAttachmentsFailure,
    loadTicketAttachmentsSuccess,
    loadTicketTypesFailure,
    loadTicketTypesSuccess,
    loadTicketCategoriesFailure,
    loadTicketCategoriesSuccess,
    loadTicketCounselsFailure,
    loadTicketCounselsSuccess,
    loadWorkersCompCoordinatorsFailure,
    loadWorkersCompCoordinatorsSuccess,
    loadTicketDetailsFailure,
    loadTicketDetailsSuccess,
    loadTicketHistoryFailure,
    loadTicketHistorySuccess,
    loadTicketTaskNoteHistoryFailure,
    loadTicketTaskNoteHistorySuccess,
    loadTicketTasksFailure,
    loadTicketTasksSuccess,
    searchEmployeesFailure,
    searchEmployeesSuccess,
    clearEmployees,
    loadUrgencyFailure,
    loadUrgencySuccess,
    updateTicketCounselFailure,
    updateTicketCounselSuccess,
    updateTicketDescriptionSuccess,
    updateTicketHistoryFailure,
    updateTicketUnitId,
    updateTicketUnitName,
    updateTicketUpdatingFlag,
    reassignTickets,
    reassignTicketsFailure,
    loadTicketSettingsCategoriesSuccess,
    loadTicketSettingsCategoriesFailure,
    loadTicketCategoryTypesSuccess,
    loadTicketCategoryTypesFailure,
    reassignTicketsSuccessfully,
    loadCandidatesSuccess,
    loadCandidatesFailure,
    updateTicketBookedDaysSuccess,
    loadTagTypesSuccess,
    loadTagTypesFailure,
    clearTicketDetails,
    toggleTicketLockStatusFailure,
    loadTicketDetails,
    updateTicket,
    reassignTicket,
    toggleTicketLockStatus,
    reopenTicket,
    loadTagTypesForCategorySuccess,
    loadTagTypesForCategoryFailure,
    updateTicketFailure,
    createStaffingAdvisoryFromTicket,
    createStaffingAdvisoryFromTicketSuccess,
    createStaffingAdvisoryFromTicketFailure,
    updateWorkersCompCoordinatorFailure,
    updateWorkersCompCoordinatorSuccess
} from 'src/app/root-store/ticket-store/actions/tickets.actions';
import { TicketingState } from 'src/app/root-store/ticket-store/state/ticketing.state';

export const ticketStoreFeatureKey = 'ticketing';

export const initialState: TicketingState = {
    ticketDetails: undefined,
    ticketHistory: [],
    ticketTasks: [],
    ticketTaskNoteHistory: [],
    employees: [],
    error: undefined,
    isForbidden: false,
    router: undefined,
    counsels: [],
    ticketTypes: [],
    categories: [],
    states: [],
    urgency: [],
    candidates: [],
    candidateContracts: [],
    isUpdating: false,
    contract: undefined,
    travelContract: undefined,
    contractLookup: null,
    ticketAttachments: [],
    settingsCategories: [],
    categoryTypes: [],
    loading: false,
    tagTypes: [],
    tagTypesForCategory: [],
    workersCompCoordinators: []
};

const ticketsReducer = createReducer(
    initialState,

    on(loadTicketSettingsCategoriesSuccess, (state, action) => ({
        ...state,
        settingsCategories: action.settingsCategories
    })),

    on(loadTicketSettingsCategoriesFailure, (state, action) => ({
        ...state,
        settingsCategories: undefined,
        error: action.error
    })),

    on(loadTicketCategoryTypesSuccess, (state, action) => ({
        ...state,
        categoryTypes: action.categoryTypes
    })),

    on(loadTicketCategoryTypesFailure, (state, action) => ({
        ...state,
        categoryTypes: undefined,
        error: action.error
    })),

    on(loadTicketDetails, reopenTicket, updateTicket, reassignTicket, toggleTicketLockStatus, (state) => ({
        ...state,
        loading: true
    })),

    on(updateTicketFailure, (state) => ({
        ...state,
        loading: false
    })),

    on(loadTicketDetailsSuccess, (state, action) => ({
        ...state,
        loading: false,
        ticketDetails: action.ticketDetails
    })),

    on(loadTicketDetailsFailure, (state, action) => ({
        ...state,
        loading: false,
        ticketDetails: undefined,
        error: action.error,
        isForbidden: action.isForbidden
    })),

    on(updateTicketDescriptionSuccess, (state, action) => ({
        ...state,
        ticketDetails: {
            ...state.ticketDetails,
            categoryNote: action.updatedNote
        }
    })),
    on(updateTicketBookedDaysSuccess, (state, action) => ({
        ...state,
        ticketDetails: {
            ...state.ticketDetails,
            bookedDays: action.updatedDescription
        }
    })),

    on(loadTicketCounselsSuccess, (state, action) => ({
        ...state,
        counsels: action.counsels
    })),

    on(loadTicketCounselsFailure, (state, action) => ({
        ...state,
        counsels: [],
        error: action.error
    })),

    on(loadWorkersCompCoordinatorsSuccess, (state, action) => ({
        ...state,
        workersCompCoordinators: action.workersCompCoordinators
    })),

    on(loadWorkersCompCoordinatorsFailure, (state, action) => ({
        ...state,
        workersCompCoordinators: [],
        error: action.error
    })),

    on(loadTicketTypesSuccess, (state, action) => ({
        ...state,
        ticketTypes: action.ticketTypes
    })),

    on(loadTicketTypesFailure, (state, action) => ({
        ...state,
        ticketTypes: [],
        error: action.error
    })),

    on(loadTicketCategoriesSuccess, (state, action) => ({
        ...state,
        categories: action.categories
    })),

    on(loadTicketCategoriesFailure, (state, action) => ({
        ...state,
        categories: [],
        error: action.error
    })),

    on(updateTicketUpdatingFlag, (state, action) => ({
        ...state,
        isUpdating: action.updateFlag
    })),

    on(updateTicketCounselSuccess, (state, action) => ({
        ...state,
        ticketDetails: {
            ...state.ticketDetails,
            counselId: action.counselId,
            counselFullName: state.counsels.find((counsel) => counsel.id === action.counselId)?.fullName
        },
        isUpdating: false
    })),

    on(updateTicketCounselFailure, (state, action) => ({
        ...state,
        isUpdating: false,
        error: action.error
    })),

    on(updateWorkersCompCoordinatorSuccess, (state, action) => ({
        ...state,
        ticketDetails: {
            ...state.ticketDetails,
            workersCompCoordinatorId: action.workersCompCoordinatorId,
            workersCompCoordinatorName: state.workersCompCoordinators.find(
                (coordinator) => coordinator.key === action.workersCompCoordinatorId
            )?.value
        },
        isUpdating: false
    })),

    on(updateWorkersCompCoordinatorFailure, (state, action) => ({
        ...state,
        isUpdating: false,
        error: action.error
    })),

    on(updateTicketUnitId, (state, action) => ({
        ...state,
        ticketDetails: {
            ...state.ticketDetails,
            unitId: action.unitId
        }
    })),

    on(updateTicketUnitName, (state, action) => ({
        ...state,
        ticketDetails: {
            ...state.ticketDetails,
            unitName: action.unitName
        }
    })),

    on(loadTicketHistorySuccess, (state, action) => ({
        ...state,
        ticketHistory: action.history
    })),

    on(loadCandidatesSuccess, (state, action) => ({
        ...state,
        candidates: action.candidates
    })),

    on(loadCandidatesFailure, (state, action) => ({
        ...state,
        candidates: [],
        error: JSON.stringify(action.error)
    })),

    on(loadTicketHistoryFailure, (state, action) => ({
        ...state,
        ticketHistory: [],
        error: action.error
    })),

    on(updateTicketHistoryFailure, (state, action) => ({
        ...state,
        error: action.error
    })),

    on(loadTicketTasksSuccess, (state, action) => ({
        ...state,
        ticketTasks: action.tasks
    })),

    on(loadTicketTasksFailure, (state, action) => ({
        ...state,
        ticketTasks: [],
        error: action.error
    })),

    on(loadTicketTaskNoteHistorySuccess, (state, action) => ({
        ...state,
        ticketTaskNoteHistory: action.noteHistory
    })),

    on(loadTicketTaskNoteHistoryFailure, (state, action) => ({
        ...state,
        ticketTaskNoteHistory: [],
        error: action.error
    })),

    on(searchEmployeesSuccess, (state, action) => ({
        ...state,
        employees: action.employees
    })),

    on(searchEmployeesFailure, (state, action) => ({
        ...state,
        employees: [],
        error: action.error
    })),

    on(clearEmployees, (state) => ({
        ...state,
        employees: []
    })),

    on(loadStatesSuccess, (state, action) => ({
        ...state,
        states: action.states
    })),

    on(loadStatesFailure, (state, action) => ({
        ...state,
        states: [],
        error: action.error
    })),

    on(loadUrgencySuccess, (state, action) => ({
        ...state,
        urgency: action.urgency
    })),

    on(loadUrgencyFailure, (state, action) => ({
        ...state,
        urgency: [],
        error: action.error
    })),

    on(loadCandidateContractsSuccess, (state, action) => ({
        ...state,
        candidateContracts: action.candidateContracts
    })),

    on(loadCandidateContractsFailure, (state, action) => ({
        ...state,
        candidateContracts: [],
        error: JSON.stringify(action.error)
    })),

    on(loadContractSuccess, (state, action) => ({
        ...state,
        contract: action.contract
    })),

    on(loadContractDetailsSuccess, (state, action) => ({
        ...state,
        travelContract: action.travelContract
    })),

    on(loadContractFailure, (state, action) => ({
        ...state,
        contract: undefined,
        error: JSON.stringify(action.error)
    })),

    on(loadContractLookupSuccess, (state, action) => ({
        ...state,
        contractLookup: action.contractLookup
    })),

    on(loadContractLookupFailure, (state, action) => ({
        ...state,
        contractLookup: null,
        error: JSON.stringify(action.error)
    })),

    on(loadTicketAttachmentsSuccess, (state, action) => ({
        ...state,
        ticketAttachments: action.ticketAttachments
    })),

    on(loadTicketAttachmentsFailure, (state, action) => ({
        ...state,
        ticketAttachments: [],
        error: JSON.stringify(action.error)
    })),

    on(reassignTickets, (state) => ({
        ...state,
        loading: true
    })),

    on(reassignTicketsSuccessfully, (state) => ({
        ...state,
        loading: false,
        error: undefined
    })),

    on(reassignTicketsFailure, (state, action) => ({
        ...state,
        loading: false,
        error: action.error
    })),

    on(loadTagTypesSuccess, (state, action) => ({
        ...state,
        tagTypes: action.tagTypes
    })),

    on(loadTagTypesFailure, (state, action) => ({
        ...state,
        tagTypes: [],
        error: action.error
    })),

    on(loadTagTypesForCategorySuccess, (state, action) => ({
        ...state,
        tagTypesForCategory: action.tagTypesForCategory
    })),

    on(loadTagTypesForCategoryFailure, (state, action) => ({
        ...state,
        tagTypesForCategory: [],
        error: action.error
    })),

    on(toggleTicketLockStatusFailure, (state, action) => ({
        ...state,
        loading: false,
        error: action.error
    })),

    on(clearTicketDetails, (state) => ({
        ...state,
        error: undefined,
        loading: false,
        ticketDetails: undefined,
        ticketHistory: [],
        ticketTasks: [],
        ticketTaskNoteHistory: [],
        ticketAttachments: [],
        isForbidden: false
    })),

    on(createStaffingAdvisoryFromTicket, (state) => ({
        ...state,
        loading: true
    })),

    on(createStaffingAdvisoryFromTicketSuccess, createStaffingAdvisoryFromTicketFailure, (state) => ({
        ...state,
        loading: false
    }))
);

export function reducer(state: TicketingState | undefined, action: Action) {
    return ticketsReducer(state, action);
}
